import { useShowMore } from 'hooks';
import { formatTimezoneSpecific } from 'utils/date';
import { AnalyticsEmployee } from 'store/api/analytics';
import { joinStrings, formatPrice } from 'utils/helpers';
import { TemplateList } from 'components/transactions-list';

import { TodayEmployeesListProps } from './types';

export const employeeConfig = {
  template: 'repeat(2, 1fr) repeat(5, 120px) 88px 88px',
  cellsMobile: [
    { row: '1/2', col: '1/3' },
    { row: '2/2', col: '1/3' },
    { row: '3/4', col: '1/2' },
    { row: '3/4', col: '2/3' },
  ],
  headers: [
    'Employee',
    'Locations',
    'Net Amount',
    'Tips',
    'Taxes',
    'Fees',
    'Gross Amount',
    'Sales QTY',
    'Last Sales',
  ],
};

export const TodayEmployeesList = ({
  data,
  title,
  setEmployee,
  timezoneCode,
}: TodayEmployeesListProps) => {
  const { visibleData, ...showMoreProps } = useShowMore(data);

  return (
    <TemplateList<AnalyticsEmployee>
      {...employeeConfig}
      data={visibleData}
      hasMinHeight={false}
      listProps={showMoreProps}
      title={title || 'Today employees'}
      tabletTemplate={employeeConfig.template}
      maxHeight={visibleData?.length ? 350 : undefined}
      onClick={setEmployee ? (e, value) => setEmployee(value) : undefined}
      render={(employeeInfo) => [
        employeeInfo.user.name,
        joinStrings(employeeInfo?.eventNames, ', '),
        formatPrice(employeeInfo.netContribution),
        formatPrice(employeeInfo.tips),
        formatPrice(employeeInfo.taxes),
        formatPrice(employeeInfo.processingFees),
        formatPrice(employeeInfo.grossContribution),
        employeeInfo.totalCheckouts,
        formatTimezoneSpecific(
          employeeInfo.lastSale.createdAt,
          timezoneCode || employeeInfo.lastSale?.event?.timezone?.code,
          'LT'
        ),
      ]}
    />
  );
};
